import styled from 'styled-components';

interface OverflowTextBodyProps {
  lines?: number;
  orientation?: 'vertical' | 'horizontal';
}

export const Container = styled.div``;

export const OverflowTextBody = styled.p<OverflowTextBodyProps>`
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: ${({ lines }: OverflowTextBodyProps) => lines ?? 1};
  -webkit-box-orient: ${({ orientation }: OverflowTextBodyProps) =>
    orientation ?? 'vertical'};
  overflow: hidden;
`;
